export default __webpack_public_path__ + "static/media/40.80f4fa96.jpg";